import React from "react";
import ReactDOM from "react-dom";
import IFeelConfigModal from "../../../app/components/modals/ConfigIFeelModal";

export default async function renderIFeelConfigModal({
  target = "modal-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<IFeelConfigModal {...rest} />, domTarget);
  }
}
